/***
 * default prefix "CHAT_GROUP"
 */

export const AT_UPDATE = 'CHAT_GROUP_UPDATE';
